import { apiBot } from 'boot/axios';

const secretService = {
    getKey: async () => {
        let key = window.sessionStorage.getItem('k1');
        if (!key) {
            await apiBot.get('hello2.php').then((response) => {
                let { data } = response;
                data = data.slice(0, -10);
                data = data.substring(12);
                data = JSON.parse(atob(data));
                sessionStorage.setItem('k1', data.kmsJs93d);
                sessionStorage.setItem('v2', data.nnzbxvVd3h);
                key = data.kmsJs93d;
            });
        }
        return key;
    },
};

export default secretService;
